import { RobotOutlined } from '@ant-design/icons'
import { Empty } from 'antd'
import { ListPageIntro, ListPageShell } from '../../common'

export const AgentsContentMarketing = () => {
	return (
		<ListPageShell>
			<ListPageIntro
				icon={RobotOutlined}
				title="Agent: Content Marketing"
				subtitle="Manage Content Marketing agent settings and prompts."
			/>
			<Empty description="Content Marketing agent page is coming soon." />
		</ListPageShell>
	)
}
